<template>
  <b-card
    no-body
    class="p-3"
  >
    <b-row align-h="center">
      <b-col
        sm="12"
        md="7"
      >
        <validation-observer ref="formRef">
          <b-form @submit.prevent>
            <b-form-group
              :label="$t('apps.masterDataTax.singular.name')"
              label-for="name"
            >
              <validation-provider
                #default="{ errors }"
                name="name"
                rules="required"
              >
                <b-form-input
                  id="tax-name"
                  v-model="form.name"
                  :state="errors.length > 0 ? false:null"
                  :placeholder="!actions.isPreview ? $t('apps.masterDataTax.placeholder.name') : null"
                  :disabled="actions.isPreview"
                />
                <small class="text-danger">{{ errors[0]}}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              :label="$t('apps.masterDataTax.singular.rate')"
              label-for="rate"
            >
              <validation-provider
                #default="{ errors }"
                rate="rate"
                rules="required"
              >
                <b-form-input
                  id="tax-rate"
                  v-model.number ="form.rate"
                  :state="errors.length > 0 ? false:null"
                  :options="numeric"
                  :placeholder="!actions.isPreview ? $t('apps.masterDataTax.singular.rate') : null"
                  :disabled="actions.isPreview"
                />
                <small class="text-danger">{{ errors[0]}}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              :label="$t('apps.masterDataTax.singular.coa')"
              label-for="coa"
            >
              <validation-provider
                #default="{ errors }"
                name="account_name"
                rules="required"
              >
                <v-select
                  id="account_name"
                  v-model="form.sell_account_id"
                  :options="LOV.account"
                  :reduce="field => field.id"
                  label="account_name"
                  :state="errors.length > 0 ? false:null"
                  :disabled="actions.isPreview"
                />
                <small class="text-danger">{{ errors[0]}}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              :label="$t('apps.masterDataTax.singular.buycoa')"
              label-for="buycoa"
            >
              <validation-provider
                #default="{ errors }"
                name="account_name"
                rules="required"
              >
                <v-select
                  id="account_name"
                  v-model="form.buy_account_id"
                  :options="LOV.account"
                  :reduce="field => field.id"
                  label="account_name"
                  :state="errors.length > 0 ? false:null"
                  :disabled="actions.isPreview"
                />
                <small class="text-danger">{{ errors[0]}}</small>
              </validation-provider>
            </b-form-group>

            <div class="mt-3 d-flex flex-sm-column flex-md-row justify-content-between">
              <b-button
                class="mb-sm-1 mb-md-0"
                :variant="actions.isPreview ? 'outline-secondary' : 'outline-primary'"
                :to="{ name: 'apps-master-data-tax-list'}"
              >
                <feather-icon
                  icon="ArrowLeftIcon"
                />
                {{ $t('globalActions.backToList') }}
              </b-button>

              <b-button
                v-if="actions.isPreview"
                class=" mb-sm-1 mb-md-0"
                variant="outline-danger"
                @click="handleDelete"
              >
                <feather-icon
                  icon="Trash2Icon"
                />
                {{ $t('globalActions.delete') }}
              </b-button>

              <b-button
                v-if="!actions.isPreview"
                variant="primary"
                type="submit"
                @click="handleSubmit"
              >
                <feather-icon
                  icon="SaveIcon"
                />
                {{ actions.isEditMode ? $t('globalActions.update') : $t('globalActions.create') }}
              </b-button>

              <b-button
                v-else
                variant="outline-primary"
                @click="changeToEdit"
              >
                <feather-icon
                  icon="EditIcon"
                />
                {{ $t('globalActions.changeToEdit') }}
              </b-button>
            </div>
          </b-form>
        </validation-observer>
      </b-col>
    </b-row>
  </b-card>
</template>

<script>
import { ref, onMounted } from '@vue/composition-api'
// import i18n from '@/libs/i18n'
import {
  BCard,
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  //BFormTextarea,
  BButton
} from 'bootstrap-vue'
import vSelect from 'vue-select'
// import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'

import useFormResource from '@/comp-functions/useFormResource'

export default {
  components: {
    BCard,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    // BFormCheckbox,
    BForm,
    //BFormTextarea,
    BButton,
    vSelect,
    // BFormText,
    // BFormDatalist,
    ValidationProvider,
    ValidationObserver
  },
  setup () {
    const { 
      paramsId,
      formRef,
      firstFocusSelectInput,
      get,
      actions,
      changeToEdit,
      show,
      destroy,
      store
    } = useFormResource({ url: 'master/tax', localeContextPath: 'apps.masterDataTax.singular.tax', redirectPathName: 'apps-master-data-tax' })

    // LOV (select option)
    const LOV = ref({
      account: []
    })

    const form = ref({
      name: '',
      rate:'',
      sell_account_id:'',
      buy_account_id:''
    })

    
    const numeric = ref({
      numeral: true,
      numeralThousandsGroupStyle: 'thousand'
    })

    // will get data to show the preview
    const getDataPreview = async () => {
      const data = await show()
      form.value.name = data[0].name
      form.value.rate = data[0].rate
      form.value.sell_account_id = data[0].sell_account_id
      form.value.buy_account_id = data[0].buy_account_id
    }

    // Get account types
    const getAccount = async () => {
      LOV.value.account = await get({ url: 'master/accounts'})

    const getDefaultCoaSell = await get({ url: 'value/get-default-coa/ACCOUNTPAYABLE'})
     if(form.value.sell_account_id == null || form.value.sell_account_id == '' ){
        form.value.sell_account_id = getDefaultCoaSell[0].account_id
      }

    const getDefaultCoabuy = await get({ url: 'value/get-default-coa/ACCOUNTPAYABLE'})
     if(form.value.buy_account_id == null || form.value.buy_account_id == '' ){
        form.value.buy_account_id = getDefaultCoabuy[0].account_id
      }

    }

    onMounted(() => {
      if (paramsId) {
        actions.value.isPreview = true
        getDataPreview()
      }
      getAccount()
    })

    return {
      required,
      form,
      paramsId,
      formRef,
      firstFocusSelectInput,
      get,
      actions,
      changeToEdit,
      show,
      destroy,
      store,
      numeric,
      LOV
    }
  },
  methods: {
    handleDelete () {
      this.destroy(this.$swal)
    },
    handleSubmit () {
      this.store({
        $swal: this.$swal,
        data: this.form
      })
    }
  }
}
</script>

<style lang="scss">
@import '@core/scss/vue/libs/vue-select.scss';
@import '@core/scss/vue/libs/vue-sweetalert.scss';
</style>
